(() => {
  'use strict';

  const body = document.body;
  if (!body || body.dataset.haEnhanced === 'true') return;
  body.dataset.haEnhanced = 'true';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  const liveRegion = document.getElementById('ha-live-region');
  const announce = (message) => {
    if (!liveRegion || !message) return;
    liveRegion.textContent = '';
    window.setTimeout(() => { liveRegion.textContent = message; }, 30);
  };

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };

  const enhanceRoot = (root = document) => {
    
    // Sizing & Fit Guide Modal Handlers
    // Atelier Pairing Suite (1-Click Upsell & Cross-sell)
    const suiteWrap = root.querySelector?.('[data-ha-addons]');
    if (suiteWrap && !suiteWrap.dataset.haSuiteBound) {
      suiteWrap.dataset.haSuiteBound = 'true';
      const suiteBtns = suiteWrap.querySelectorAll('[data-addon-btn]');
      suiteBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const card = btn.closest('.ha-v9-suite-card');
          const isPressed = btn.getAttribute('aria-pressed') === 'true';
          const name = btn.dataset.addonName || 'Accessory';
          if (isPressed) {
            btn.setAttribute('aria-pressed', 'false');
            btn.classList.remove('is-added');
            card?.classList.remove('is-active');
            btn.querySelector('.ha-v9-suite-btn-label').textContent = '+ Add';
            announce(name + ' removed from pairing suite');
          } else {
            btn.setAttribute('aria-pressed', 'true');
            btn.classList.add('is-added');
            card?.classList.add('is-active');
            btn.querySelector('.ha-v9-suite-btn-label').textContent = '✓ Added';
            announce(name + ' added to pairing suite');
          }
        });
      });
    }

    // Escape key modal close handler
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const modal = document.getElementById('HaFitGuideModal');
        if (modal && modal.classList.contains('is-active')) {
          modal.classList.remove('is-active');
          modal.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = '';
        }
      }
    });

    root.querySelectorAll?.('[data-ha-fit-guide-trigger],[aria-controls="HaFitGuideModal"]').forEach((trigger) => {
      if (trigger.dataset.haFitBound === 'true') return;
      trigger.dataset.haFitBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const modal = document.getElementById('HaFitGuideModal');
        if (!modal) return;
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      });
    });

    root.querySelectorAll?.('#HaFitGuideModal [data-ha-modal-close]').forEach((closer) => {
      if (closer.dataset.haCloseBound === 'true') return;
      closer.dataset.haCloseBound = 'true';
      closer.addEventListener('click', () => {
        const modal = document.getElementById('HaFitGuideModal');
        if (!modal) return;
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      });
    });

    root.querySelectorAll?.('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', [...rel].join(' '));
    });

    root.querySelectorAll?.('button:not([type])').forEach((button) => {
      if (!button.closest('form') || button.matches('[aria-controls],[aria-expanded],[class*="close"],[class*="toggle"],.hdt-filter_btn')) {
        button.type = 'button';
      }
    });

    root.querySelectorAll?.('input:not([type="hidden"]):not([aria-label]):not([aria-labelledby]),textarea:not([aria-label]):not([aria-labelledby])').forEach((field) => {
      if (field.id && document.querySelector(`label[for="${escapeSelector(field.id)}"]`)) return;
      const label = field.getAttribute('placeholder') || field.getAttribute('name');
      if (label) field.setAttribute('aria-label', label.replace(/[_-]+/g, ' '));
    });

    root.querySelectorAll?.('form:not([data-ha-form])').forEach((form) => {
      form.dataset.haForm = 'true';
      form.addEventListener('submit', () => {
        form.classList.add('ha-is-submitting');
        form.setAttribute('aria-busy', 'true');
        window.setTimeout(() => {
          form.classList.remove('ha-is-submitting');
          form.removeAttribute('aria-busy');
        }, 8000);
      });
    });

    root.querySelectorAll?.('[data-ha-drag-scroll]:not([data-ha-drag-ready])').forEach((scroller) => {
      scroller.dataset.haDragReady = 'true';
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      const finish = () => {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
      };
      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.target.closest('button,input,select,textarea')) return;
        isDown = true;
        moved = false;
        startX = event.clientX;
        startScroll = scroller.scrollLeft;
        scroller.setPointerCapture?.(event.pointerId);
      });
      scroller.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5) {
          moved = true;
          scroller.classList.add('is-dragging');
          scroller.scrollLeft = startScroll - distance;
        }
      });
      scroller.addEventListener('pointerup', finish);
      scroller.addEventListener('pointercancel', finish);
      scroller.addEventListener('lostpointercapture', finish);
      scroller.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    });
  };

  const enhanceFaq = () => {
    const source = document.querySelector('[data-ha-faq-source]');
    if (!source || source.dataset.haFaqEnhanced === 'true') return;
    source.dataset.haFaqEnhanced = 'true';
    const nodes = [...source.children];
    if (!nodes.length) return;
    const fragment = document.createDocumentFragment();
    let group = null;
    let converted = 0;

    const makeGroup = (headingText) => {
      const wrapper = document.createElement('section');
      wrapper.className = 'ha-faq-group';
      if (headingText) {
        const heading = document.createElement('h2');
        heading.textContent = headingText;
        wrapper.appendChild(heading);
      }
      fragment.appendChild(wrapper);
      return wrapper;
    };

    nodes.forEach((node) => {
      if (/^H[2-4]$/.test(node.tagName)) {
        group = makeGroup(node.textContent.trim());
        return;
      }
      if (node.tagName === 'P') {
        const strong = node.querySelector(':scope > strong:first-child');
        const strongText = strong?.textContent.trim() || '';
        if (/^Q\s*:/i.test(strongText)) {
          if (!group) group = makeGroup('Questions');
          const details = document.createElement('details');
          details.className = 'ha-faq-item';
          const summary = document.createElement('summary');
          summary.textContent = strongText.replace(/^Q\s*:\s*/i, '');
          const answer = document.createElement('div');
          answer.className = 'ha-faq-answer';
          const clone = node.cloneNode(true);
          clone.querySelector(':scope > strong:first-child')?.remove();
          const answerText = clone.innerHTML.replace(/^\s*[:–—-]?\s*/, '').trim();
          answer.innerHTML = answerText || '<p>Please contact our client services team for assistance.</p>';
          details.append(summary, answer);
          group.appendChild(details);
          converted += 1;
          return;
        }
      }
      if (!group) group = makeGroup('Information');
      group.appendChild(node.cloneNode(true));
    });
    if (converted > 0) source.replaceChildren(fragment);
  };

  let activeFilterDrawer = null;
  let filterReturnFocus = null;
  let filterHideTimer = 0;

  const closeFilterDrawer = ({ restoreFocus = true } = {}) => {
    if (!activeFilterDrawer) return;
    const drawer = activeFilterDrawer;
    const collection = drawer.closest('[data-ha-collection]');
    const overlay = collection?.querySelector('[data-ha-filter-overlay]');
    const opener = collection?.querySelector('[data-ha-filter-open]');
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    opener?.setAttribute('aria-expanded', 'false');
    body.classList.remove('ha-filter-open');
    window.clearTimeout(filterHideTimer);
    filterHideTimer = window.setTimeout(() => {
      if (overlay && !overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 360);
    activeFilterDrawer = null;
    if (restoreFocus) (filterReturnFocus || opener)?.focus?.();
    filterReturnFocus = null;
  };

  const openFilterDrawer = (opener) => {
    const collection = opener.closest('[data-ha-collection]');
    const drawer = collection?.querySelector('[data-ha-filters]');
    const overlay = collection?.querySelector('[data-ha-filter-overlay]');
    if (!drawer || !overlay) return;
    closeFilterDrawer({ restoreFocus: false });
    window.clearTimeout(filterHideTimer);
    filterReturnFocus = opener;
    activeFilterDrawer = drawer;
    overlay.hidden = false;
    window.requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      body.classList.add('ha-filter-open');
      drawer.querySelector('[data-ha-filter-close], input, button, select, a')?.focus();
    });
  };

  const trapFilterFocus = (event) => {
    if (!activeFilterDrawer || event.key !== 'Tab') return;
    const items = [...activeFilterDrawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')]
      .filter((item) => item.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  let submitTimer = 0;
  const submitFieldForm = (field) => {
    const form = field.form || field.closest('form');
    if (!form) return;
    window.clearTimeout(submitTimer);
    submitTimer = window.setTimeout(() => {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }, field.matches('select') ? 40 : 260);
  };

  const shareCurrentPage = async (button) => {
    const title = document.querySelector('h1')?.textContent?.trim() || document.title;
    try {
      if (navigator.share) {
        await navigator.share({ title, url: window.location.href });
        announce('Share options opened.');
        return;
      }
      await navigator.clipboard.writeText(window.location.href);
      const original = button.textContent;
      button.textContent = 'Link copied';
      announce('Product link copied to clipboard.');
      window.setTimeout(() => { button.textContent = original; }, 2200);
    } catch (error) {
      if (error?.name !== 'AbortError') announce('Unable to share this page.');
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ha-filter-open]');
    if (openButton) {
      event.preventDefault();
      openFilterDrawer(openButton);
      return;
    }
    if (event.target.closest('[data-ha-filter-close],[data-ha-filter-overlay]')) {
      event.preventDefault();
      closeFilterDrawer();
      return;
    }
    const shareButton = event.target.closest('[data-ha-share]');
    if (shareButton) {
      event.preventDefault();
      shareCurrentPage(shareButton);
    }
  });

  document.addEventListener('change', (event) => {
    const field = event.target.closest('[data-ha-auto-submit]');
    if (!field) return;
    if (field.type === 'checkbox' && !window.matchMedia('(min-width: 990px)').matches) return;
    submitFieldForm(field);
  });

  const resetQuickAdd = (button, { success = false } = {}) => {
    if (!button) return;
    window.clearTimeout(Number(button.dataset.haResetTimer || 0));
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    const label = button.querySelector('span');
    if (label) label.textContent = success ? 'Added' : (button.dataset.haOriginal || 'Add to bag');
    if (success) {
      button.dataset.haResetTimer = String(window.setTimeout(() => {
        if (label) label.textContent = button.dataset.haOriginal || 'Add to bag';
      }, 1600));
    }
  };

  document.addEventListener('submit', (event) => {
    const quickForm = event.target.closest('[data-ha-quick-add]');
    if (!quickForm) return;
    const button = quickForm.querySelector('[type="submit"]');
    if (!button) return;
    button.dataset.haOriginal = button.querySelector('span')?.textContent || 'Add to bag';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    const label = button.querySelector('span');
    if (label) label.textContent = 'Adding…';
    button.dataset.haResetTimer = String(window.setTimeout(() => resetQuickAdd(button), 9000));
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeFilterDrawer) closeFilterDrawer();
    trapFilterFocus(event);
  });

  document.addEventListener('cart:change', () => {
    document.querySelectorAll('[data-ha-quick-add] [type="submit"].is-loading').forEach((button) => resetQuickAdd(button, { success: true }));
    announce('Product added to bag.');
  });
  document.addEventListener('cart:error', () => {
    document.querySelectorAll('[data-ha-quick-add] [type="submit"].is-loading').forEach((button) => resetQuickAdd(button));
    announce('The item could not be added. Please try again.');
  });

  enhanceRoot();
  enhanceFaq();

  let scrollFrame = 0;
  const syncScroll = () => {
    body.classList.toggle('ha-scrolled', window.scrollY > 14);
    scrollFrame = 0;
  };
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(syncScroll);
  }, { passive: true });
  syncScroll();

  let lastCartCount = null;
  const readCartCount = () => {
    for (const selector of ['[data-cart-count]', '.hdt-cart-count', '.hdt-header-cart__count']) {
      const node = document.querySelector(selector);
      const count = Number.parseInt(node?.textContent?.trim() || '', 10);
      if (Number.isFinite(count)) return count;
    }
    return null;
  };

  const observer = new MutationObserver((mutations) => {
    const roots = new Set();
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) roots.add(node);
    }));
    roots.forEach((root) => enhanceRoot(root));
    const count = readCartCount();
    if (count !== null && lastCartCount !== null && count !== lastCartCount) {
      announce(count === 1 ? 'Bag updated. 1 item in bag.' : `Bag updated. ${count} items in bag.`);
    }
    if (count !== null) lastCartCount = count;
  });
  observer.observe(document.body, { childList: true, subtree: true });
  lastCartCount = readCartCount();

  document.addEventListener('shopify:section:load', (event) => {
    enhanceRoot(event.target);
    enhanceFaq();
  });
})();
